var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#090A0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6021 6.44864L12.5 11.5507L7.3979 6.44864C7.135 6.18574 6.71008 6.18574 6.44718 6.44864C6.18427 6.71154 6.18427 7.13646 6.44718 7.39936L11.5493 12.5015L6.44718 17.6005C6.18427 17.8634 6.18427 18.2883 6.44718 18.5512C6.71008 18.8141 7.135 18.8141 7.3979 18.5512L12.5 13.4491L17.6021 18.5512C17.865 18.8141 18.2899 18.8141 18.5528 18.5512C18.8157 18.2883 18.8157 17.8634 18.5528 17.6005L13.4507 12.5015L18.5528 7.39936C18.8157 7.13646 18.8157 6.71154 18.5528 6.44864C18.2899 6.18574 17.865 6.18574 17.6021 6.44864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9bc686944d39169984767f9180f5a829.svg";
export { ForwardRef as ReactComponent };